// Which admin page belongs to which section. The server checks every request too;
// this only decides what a worker sees in the menu.
export const PAGE_SECTION = {
    "/admin": "dashboard",
    "/admin/exchanges": "exchanges",
    "/admin/users": "users",
    "/admin/workers": "owner",
    "/admin/kyc": "kyc",
    "/admin/giftcards": "giftcards",
    "/admin/payout-methods": "payout_methods",
    "/admin/transactions": "transactions",
    "/admin/withdrawals": "withdrawals",
    "/admin/accounting": "accounting",
    "/admin/rewards": "rewards",
    "/admin/safety": "safety",
    "/admin/marketplace": "marketplace",
    "/admin/giftcard-store": "giftcard_store",
    "/admin/ads": "ads",
    "/admin/ad-profit": "ads",
    "/admin/social": "social",
    "/admin/video-studio": "social",
    "/admin/email-campaigns": "email",
    "/admin/ai-studio": "ai_studio",
    "/admin/broadcasts": "broadcasts",
    "/admin/live-feed": "live_feed",
    "/admin/blog": "blog",
    "/admin/tickets": "tickets",
    "/admin/notifications": "notifications",
    "/admin/settings": "settings",
    "/admin/logs": "logs",
    "/admin/google-ads": "google_ads",
    "/admin/tiktok-ads": "ads",
    "/admin/system": "owner",
};

export const isStaff = (u) => u && u.role === "staff";
export const isAdminArea = (u) => u && (u.role === "admin" || u.role === "staff");
export const homeFor = (u) => (isAdminArea(u) ? "/admin" : "/dashboard");

export function sectionForPath(pathname) {
    const p = (pathname || "").replace(/\/+$/, "") || "/";
    if (PAGE_SECTION[p]) return PAGE_SECTION[p];
    const hit = Object.keys(PAGE_SECTION).filter((k) => k !== "/admin" && p.startsWith(k + "/")).sort((a, b) => b.length - a.length)[0];
    return hit ? PAGE_SECTION[hit] : null;
}

export function canSee(user, pathname) {
    if (!user) return false;
    if (user.role === "admin") return true;
    if (user.role !== "staff") return false;
    const sec = sectionForPath(pathname);
    if (!sec || sec === "owner") return false;
    return (user.sections || []).includes(sec);
}
